// extracted by mini-css-extract-plugin
export default {"footer":"LandingPage_footer__SGOqM","LandingPage":"LandingPage_LandingPage__LVZPJ"};